import React, { useEffect, useState } from 'react';
import { Rocket } from 'lucide-react';

// Tracks page scroll progress as a 0-1 value
function useScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // onScroll is defined inside the effect, so the empty dependency
    // array is correct — nothing reactive is captured.
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(max > 0 ? Math.min(1, window.scrollY / max) : 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return progress;
}

// Fixed rocket on right edge that climbs as you scroll
export default function RocketProgress() {
  const progress = useScrollProgress();

  return (
    <div className="rocket-progress" aria-hidden="true" data-testid="rocket-progress">
      <div className="rocket-progress-track">
        <div className="rocket-progress-fill" style={{ height: `${progress * 100}%` }} />
        <div className="rocket-progress-ship" style={{ bottom: `calc(${progress * 100}% - 14px)` }}>
          <Rocket size={20} />
        </div>
      </div>
    </div>
  );
}
